// Kept in its own module so the landing page (BlogTeaser) can link to a post
// without importing ./index — which pulls in the full manifest and the
// import.meta.glob thunks for every article.

/** The language a post is actually WRITTEN in. Not a UI preference. */
export type BlogPostLanguage = "en" | "es";

/**
 * Canonical path of a post: its language decides the prefix. Spanish articles
 * live under /es/blog/<slug> so the URL, the `<html lang>`, and the interface
 * chrome a visitor from Google lands on all agree. There is exactly ONE URL
 * per post — the EN + /es pair published the same body twice.
 *
 * KEEP IN SYNC with postPath() in scripts/blog-meta.mjs (the build-time
 * emitters can't import TS).
 */
export function blogPostPath(post: { id: string; language: BlogPostLanguage }): string {
  return post.language === "es" ? `/es/blog/${post.id}` : `/blog/${post.id}`;
}
